/* eslint-disable @angular-eslint/directive-selector */

import { Directive, inject } from '@angular/core';
import { LayoutContainerComponent } from '../components/basic/layout-container/layout-container.component';

@Directive({ selector: 'app-layout-container[fluid]' })
export class ContainerFluidDirective {
  private container = inject(LayoutContainerComponent);

  constructor() {
    this.container.fluid.set(true);
  }
}
